/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerFragmentDoc } from '../SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AutoChatReplySettingExtraType =
  | 'BOOKING_REQUEST'
  | 'NONE'
  | 'QUESTION';

export type FetchAutoChatReplySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAutoChatReplySettingsQuery = { viewer: { autoChatReplySettings: Array<{ id: string, keyword: string, isEnabled: boolean, extra: { type: Types.AutoChatReplySettingExtraType } }> }, planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, uiControl: { editCorporation: boolean } };

export type DeleteAutoChatReplySettingsMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type DeleteAutoChatReplySettingsMutation = { deleteAutoChatReplySettings: { isSucceeded: boolean } };


export const FetchAutoChatReplySettingsDocument = gql`
    query FetchAutoChatReplySettings {
  viewer {
    autoChatReplySettings {
      id
      keyword
      isEnabled
      extra {
        type
      }
    }
  }
  planner {
    ...SettingsPagePlanner
  }
  uiControl {
    editCorporation
  }
}
    ${SettingsPagePlannerFragmentDoc}`;

/**
 * __useFetchAutoChatReplySettingsQuery__
 *
 * To run a query within a Vue component, call `useFetchAutoChatReplySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAutoChatReplySettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchAutoChatReplySettingsQuery();
 */
export function useFetchAutoChatReplySettingsQuery(options: VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>(FetchAutoChatReplySettingsDocument, {}, options);
}
export function useFetchAutoChatReplySettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>(FetchAutoChatReplySettingsDocument, {}, options);
}
export type FetchAutoChatReplySettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchAutoChatReplySettingsQuery, FetchAutoChatReplySettingsQueryVariables>;
export const DeleteAutoChatReplySettingsDocument = gql`
    mutation deleteAutoChatReplySettings($ids: [ID!]!) {
  deleteAutoChatReplySettings(ids: $ids) {
    isSucceeded
  }
}
    `;

/**
 * __useDeleteAutoChatReplySettingsMutation__
 *
 * To run a mutation, you first call `useDeleteAutoChatReplySettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutoChatReplySettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAutoChatReplySettingsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAutoChatReplySettingsMutation(options: VueApolloComposable.UseMutationOptions<DeleteAutoChatReplySettingsMutation, DeleteAutoChatReplySettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAutoChatReplySettingsMutation, DeleteAutoChatReplySettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAutoChatReplySettingsMutation, DeleteAutoChatReplySettingsMutationVariables>(DeleteAutoChatReplySettingsDocument, options);
}
export type DeleteAutoChatReplySettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAutoChatReplySettingsMutation, DeleteAutoChatReplySettingsMutationVariables>;